import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NavigationError, NavigationStart, Router, RouterModule } from '@angular/router';
import { RegistrationAppBar } from '@shareview-health/configuration/shared';
import { ApplicationInsightService, makeContextProps } from '@shareview-health/shared';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, map } from 'rxjs';

@Component({
  imports: [RouterModule, AsyncPipe, MatButton, NgOptimizedImage, RegistrationAppBar],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly applicationInsightService = inject(ApplicationInsightService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);

  public constructor() {
    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e: any) => {
      this.applicationInsightService.trackEvent({
        name: 'router.navigation_start',
        properties: makeContextProps({ url: e.url }),
      });
    });

    this.router.events.pipe(filter((e) => e instanceof NavigationError)).subscribe((e: any) => {
      this.applicationInsightService.trackException({
        exception: e.error ?? new Error('NavigationError'),
        properties: makeContextProps({ url: e.url, source: 'router.NavigationError' }),
      });
    });

    this.router.events.pipe(filter((e) => e instanceof NavigationError)).subscribe((e: any) => {
      this.applicationInsightService.trackException(e.error ?? new Error('NavigationError'), {
        navUrl: e.url,
        source: 'router.NavigationError',
      });
    });

    this.oidcSecurityService.isAuthenticated$.subscribe((s) => {
      this.applicationInsightService.trackEvent({
        name: 'oidc.isAuthenticated',
        properties: makeContextProps({
          isAuthenticated: String(s.isAuthenticated),
          allConfigsAuthenticated: String(s.allConfigsAuthenticated),
        }),
      });
    });
  }

  protected readonly isAuthenticated$ = this.oidcSecurityService.isAuthenticated$.pipe(
    map((result) => result.isAuthenticated)
  );

  public ngOnInit(): void {
    this.applicationInsightService.trackPageView();
  }

  protected login(): void {
    this.applicationInsightService.trackEvent({ name: 'login.click' }, { href: location.href });
    try {
      this.oidcSecurityService.authorize();
    } catch (e) {
      this.applicationInsightService.logError(e as any);
    }
  }

  protected logout(): void {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe();
  }
}
